import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components'

export const StyledToolCarousel = styled.div`
  width: 100%;
  .mantine-Carousel-indicator {
    width: 8px;
    height: 8px;
    ${MediaQueries.mbDown} {
      background: ${theme?.colors.pink800};
      transform: translateY(32px);
    }
  }
`
export const StyledTool = styled.div`
  background: ${theme?.colors.pink800};
  border-radius: ${theme.borderRadius};
  height: 100%;
  & > div {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-block: 50px;
  }
  .wrapper {
    margin: 0 auto;
    display: flex;
    gap: 60px;
    max-width: 800px;
    align-items: center;
  }
  .content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    a {
      width: fit-content;
    }
  }
  .subtitle {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .reviewer {
  }
  .banner {
    img {
      width: 180px;
      height: 180px;
    }
  }
  .button {
    background-color: #ffffff;
    color: ${theme?.colors.pink800};
    border: none;
  }
  ${MediaQueries.mbDown} {
    padding: 16px;
    & > div {
      padding-block: 16px;
    }
    .wrapper {
      gap: 8px;
    }
    .content {
      max-width: 250px;
    }
    .banner {
      img {
        width: 100px;
        height: 100px;
      }
    }
  }
`
